// window.__hashcurve: read-only debug hooks for verifying the app in a real browser.
// Values are live snapshots (bigints kept as bigints); __hashcurve.dump() returns JSON.
type DebugRoot = Record<string, unknown> & { dump: () => string };

function root(): DebugRoot | null {
  if (typeof window === 'undefined') return null;
  const w = window as unknown as { __hashcurve?: DebugRoot };
  if (!w.__hashcurve) {
    const r: DebugRoot = {
      dump: () => JSON.stringify(r, (_k, v) => (typeof v === 'bigint' ? v.toString() : v), 2),
    };
    w.__hashcurve = r;
  }
  return w.__hashcurve;
}

export function debugSet(key: string, value: unknown): void {
  const r = root();
  if (r) r[key] = value;
}
